module.exports = __webpack_public_path__ + "static/media/blog-detail-2.24c718b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog-detail-2.jpg
// module id = 1108
// module chunks = 33